import { motion } from 'framer-motion'
import React, { useEffect } from 'react'
import toast from 'react-hot-toast'
import { AiOutlineRight } from 'react-icons/ai'
import { BsBellFill } from 'react-icons/bs'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import Title from '@/components/Title'
import useCheckDevice from '@/hooks/useCheckDevice'

import Begin from './components/Begin'
import Guide from './components/Guide'
import Last from './components/Last'
import User from './components/User'

export default function Index() {
  const [msg] = useCheckDevice()

  useEffect(() => {
    if (msg) {
      toast(msg, { icon: <BsBellFill className="text-[#ff3300]" /> })
    }
  }, [msg])

  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }}>
      <User />
      <Title title="即将开始" className="mt-[20px]">
        <NavLink to="/center/myTimeTable" className="flex items-center justify-center font-medium hover:text-[#ff3300] text-[14px] text-[#999]">
          查看更多 <AiOutlineRight />
        </NavLink>
      </Title>
      <Begin />
      <Title title="最近一次上课记录" className="mt-[20px]">
        <NavLink to="/center/finishClass" className="flex items-center justify-center font-medium hover:text-[#ff3300] text-[14px] text-[#999]">
          查看更多 <AiOutlineRight />
        </NavLink>
      </Title>
      <Last />
      <Title title="美术宝1对1指导视频" className="mt-[20px]" />
      <Guide />
    </Container>
  )
}

const Container = styled(motion.div)``
